import React from "react";
import { Link } from "react-router-dom";
import "../styles/Terms&Conditions.css";

const TermsConditions = () => {
  return (
    <div className="legal-page">
      {/* PAGE HEADER */}
      <div className="legal-header">
        <h1>Terms and Conditions</h1>
        <p>
          <Link to="/">Home</Link> / <span>Terms and Conditions</span>
        </p>
      </div>

      {/* PAGE CONTENT */}
      <div className="legal-content">
        <h2>Introduction</h2>
        <p>
          SPARSH CARGO PRIVATE LIMITED ("Website" or "www.sparshcargo.com") is
          owned by SPARSH CARGO PRIVATE LIMITED ("SPARSH CARGO", "we", "us").
          By using this website, you agree to be bound by these Terms and
          Conditions, which may be revised from time to time without notice.
        </p>

        <h2>Ownership of Rights</h2>
        <p>
          Any use of this website or its contents, including copying, storing,
          modifying, reproducing, or distributing, other than for personal,
          non-commercial use, is prohibited without written permission from
          SPARSH CARGO PRIVATE LIMITED.
        </p>

        <p>
          All content displayed on this website is protected by copyright and
          intellectual property laws. All rights are owned or licensed by
          SPARSH CARGO PRIVATE LIMITED.
        </p>

        <h2>Disclaimer</h2>
        <p>
          All information, services, names, images, and content on this website
          are provided “as is”. SPARSH CARGO PRIVATE LIMITED disclaims all
          warranties, express or implied, including merchantability and fitness
          for a particular purpose.
        </p>

        <p>
          Use of this website is at your own risk. The information provided is
          not intended to be legal or professional advice.
        </p>

        <p>
          SPARSH CARGO PRIVATE LIMITED shall not be liable for any direct,
          indirect, incidental, or consequential damages arising from the use
          of this website.
        </p>

        <h2>Website Security</h2>
        <p>
          SPARSH CARGO PRIVATE LIMITED makes reasonable efforts to keep this
          website free from viruses but does not guarantee complete security.
          Users should take necessary precautions before downloading content.
        </p>

        <h2>Governing Law</h2>
        <p>
          These Terms and Conditions shall be governed by the laws of India.
          Courts located in Delhi shall have exclusive jurisdiction.
        </p>

        <h2>Communication</h2>
        <p>
          By using this website, you consent to receive communications from us
          electronically via email or website notifications.
        </p>

        <h2>User Feedback & Content</h2>
        <p>
          Any comments, feedback, or submissions provided by users become the
          property of SPARSH CARGO PRIVATE LIMITED. We reserve the right to use,
          reproduce, modify, or distribute such content without compensation.
        </p>

        <p>
          Users agree not to submit unlawful, abusive, defamatory, or harmful
          content.
        </p>

        <h2>Privacy Policy</h2>
        <p>
          Customer information is used solely for service communication,
          delivery updates via SMS, WhatsApp, or email, and service improvement.
        </p>

        <p>
          To learn more, please review our{" "}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
